"use client";

import { Row, Col, Card } from "react-bootstrap";
import PaperFullTable from "../Tables/Paper/List";

const PaperFull = () => {
    return (
        <Row>
            <Col>
                <Card className="bg-white border-0 rounded-3 mb-4">
                    <Card.Body className="p-4">
                        <PaperFullTable />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default PaperFull;